export const cardItems = [
    {
        src: '/assets/images/card/Mini/2.0/stack.svg',
        title: 'Cash Out With Ease',
        text: 'Convert crypto assets to fiat in a few taps and use them wherever cards are accepted.',
        id: 'convert',
    },
    {
        src: '/assets/images/card/Mini/2.0/cashBack.svg',
        title: 'Spend While Earning',
        text: 'Use your Crypto Debit Card with your staked assets or staking rewards for normal spending.',
        id: 'staking_rewards.',
    },
    {
        src: '/assets/images/card/Mini/2.0/Boost_APY.svg',
        title: 'Get More',
        text: 'Spend with your Crypto Debit Card to earn cashback and unlock various perks in the app.',
        id: 'cashback',
    },
    {
        src: '/assets/images/card/Mini/2.0/yourMoney.svg',
        title: 'Stay Efficient',
        text: 'Use your Crypto Debit Card with zero hidden fees - your money, your way.',
        id: 'your_money',
    }
]
